var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLocationPinPurple = function SvgLocationPinPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 .5A8.26 8.26 0 0 0 .75 8.75c0 7.059 7.5 12.39 7.819 12.614a.752.752 0 0 0 .861 0c.32-.223 7.82-5.555 7.82-12.614A8.26 8.26 0 0 0 9 .5Zm0 5.25a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z",
    fill: "#7160C5"
  })));
};

export default SvgLocationPinPurple;